import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import datasetRequests from './dataset-requests'
import Dataset from './model/dataset'
const { TOTAL } = Dataset
import LabelForm from 'scoreboard/components/label-form'
import appDisplay from 'scoreboard/components/app-display'
import conductor from 'scoreboard/components/conductor'
import i18n from 'scoreboard/components/i18n'
import saveControls from 'scoreboard/components/save-controls.hbs'
import guard from 'scoreboard/components/unsaved/guard'
import tabs from './datasets-tabs.hbs'
import globals from 'scoreboard/components/globals'
import SendToOptions from 'scoreboard/components/send-to-options'
import DatasetsDisplayHeader from './datasets-display-header'
import BusyButton from 'scoreboard/components/busy-button'
import DatasetFilters from './dataset-filters'
import ErrorView from 'scoreboard/components/error-view'
import arrayToHash from 'scoreboard/components/array-to-hash'
import wrapModel from 'scoreboard/components/wrap-model'
import DatasetNotReady from 'scoreboard/datasets/not-available/dataset-not-ready'
import {isSpectating} from 'scoreboard/components/spectator'
import DatasetTable from 'scoreboard/datasets/model/dataset-table'
import errorHandler from 'scoreboard/components/error-handler'

var debug = false

var DatasetsQueryView = Backbone.View.extend({

	// whether records should be retrieved along with the query
	records: false,
	// whether tables should be retrieved along with the query
	showTables: false,
	// The API route to invoke when export unsaved changes
	unsavedExportRoute: 'datasets',

	className: 'datasets-query-view',

	events: {
		'click .cancel': 'cancel',
		'click .save-as-new': 'saveAsNew',
		'click .save': 'save'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * Base View for Datasets | Overview and Datasets | Records.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the Dataset
	 *
	 * @param {Object} options.request the DatasetsQueryRequest that was sent to
	 * the server
	 *
	 * @param {Object} [options.response] The entire DatasetsQueryResponse returned
	 * from the server.  Optionally, this view can be constructed with just a (root)
	 * dataset model when the default (first) dataset in the tree is loaded for an
	 * org upon navigation into the dataset's section; in which case the response
	 * will default to `{dataset: this.model}`
	 *
	 * @param {Array} options.filters the filters applied to the dataset
	 */
	initialize: function(options) {
		this.options = options || {}
		this.request = this.options.request || {}
		// if it's the first dataset when clicking into the dataset section the
		// model will be provided by app-router.js using `/api/datasets/id`
		// and not `api/datasets/id/query` so we can just adapt that here
		this.response = this.options.response || {dataset: this.model}
		this.initializeTables()
		this.initializeFilters()
		this.recordOriginalState()
		this.indexTrees()

		// when not switching between overview and records tabs, clear the
		// dataset request
		Backbone.history.once('route', function(router, name, args) {
			var overviewUrl = 'datasets/' + this.model.id
			var recordsUrl = overviewUrl + '/records'
			if (Backbone.history.fragment != overviewUrl &&
				Backbone.history.fragment != recordsUrl) {
				datasetRequests.remove(this.model.id)
			}
		}.bind(this))

		// If window or nav-pane is resized, recalculate max-width on display-period
		this.on('resize', function() {
			this.header.setPeriodDisplayMaxWidth()
		}.bind(this))

		let {model, treeItemsById} = this
		let {numResults, maxResults, filters} = this.response
		this.filtersView = new DatasetFilters({model, filters, treeItemsById, numResults, maxResults})

		this.listenTo(this.filtersView, 'change', filters => {
			this._setFilters(filters)
			this.dirty(true)
			this.query({filters})
		})

		this.filtersView.on('all', () => this.togglePeriodDisplay())
	},

	initializeTables: function(tables) {
		const tablesToConstruct = tables || this.request.tables || this.response.dataset.tables || []
		this.tables = _.map(tablesToConstruct, table => new DatasetTable(table))
	},

	initializeFilters: function() {
		// all filters applied to the dataset (including security filters)
		this.filters = _.get(this.request, 'filters')
		if (_.isNil(this.filters)) {
			// see if there were any filters sent from the server (e.g. for a
			// dataset view)
			this.filters = this.response.filters
		} else {
			// be sure to show any permission filters
			let requestedPermissionIds = _(this.filters)
				.map(f => f.permissionId)
				.filter(permissionId => !_.isNil(permissionId))
				.value()
			requestedPermissionIds = arrayToHash(requestedPermissionIds)
			let permissionFilters = _.filter(this.response.filters,
				filter => !_.isNil(filter.permissionId) &&
					!requestedPermissionIds[filter.permissionId])
			this.filters = this.filters.concat(permissionFilters)
			// if we pulled filters from this.request, it means they were pulled
			// from the sessionStorage rather than the database, which may be
			// dirty
			this.dirty(this.request.dirty)
		}
	},

	/**
	 * If the dataset is stale or loading, show the banner which indicates that.
	 */
	 showRecalculationBannerIfNeeded() {
		let status = this.model.get('status')
		if (status == Dataset.STALE || status == Dataset.LOADING) {
			this.showBanner(i18n.get('datasets.updatedDataAvailableSoon'))
		}
	},

	// records the state that should be returned to if the user clicks Cancel
	recordOriginalState: function() {
		this.originalRequest = _.cloneDeep(this.request)
		this.originalFilters = _.cloneDeep(this.filters)
		this.originalResponse = _.cloneDeep(this.response)
		this.originalTables = _.cloneDeep(this.tables)
		this.originalSelectedCalendarFieldId = this.model.get('selectedCalendarFieldId')
	},

	indexTrees: function() {
		if (!this.treeItemsById) {
			this.treeItemsById = {}
		}
		_.extend(this.treeItemsById, _.keyBy(this.response.treeItems, 'id'))
	},

	createHeader: function(subsection) {
		this.header = new DatasetsDisplayHeader({
			heading: this.model.get('label'),
			model: this.model,
			subsection,
			sendToOptions: this.createSendToOptions(),
			tabs: tabs({
				id: this.model.id,
				section: 'datasets'
			}),
			drilldown: this.options.drilldown
		})
		this.header.changePeriod = () => {
			// #27901 actually changing the period isn't savable
			// this.dirty(true)
			this.query()
		}
	},

	createSendToOptions: function () {
		var sendToOpts = SendToOptions.defaultNoExport({section: 'datasets'})

		const options = {
			uiState: () => this.dirty() ? this.request : undefined,
			exportURL: () => {
				if (this.dirty()) {
					return this.unsavedExportRoute
				}
			},
			domainId: () => this.model.id,
			// All the Dataset specific rules for handling excel exports
			excelFn: this.exportTable && this.exportTable.bind(this),
			validateFn: () => {
				if (!this.isExportable()) {
					const title = i18n.get('datasets.export.error.title')
					const message = i18n.get('datasets.export.error.message')
					return new ErrorView({title, message})
				}
			}
		}
		sendToOpts = sendToOpts.concat(SendToOptions.exportServerOptions(options))
		return sendToOpts
	},

	/**
	 * Renders the panel that will contain active and security filters and
	 * renders the security filters.  Note we don't render the active filters
	 * here because that wouldn't work well for the Datasets Overview.
	 */
	prepFilters() {
		let classes = this.filtersView.el.className
		this.filtersView.setElement(this.$('.filters'))
		this.filtersView.$el.addClass(classes)
		this.filtersView.renderPanel()
		this.filtersView.renderSecurityFilters()
	},

	//adapter method so that we don't break subclasses of this view when this logic was refactor into it's own view
	renderActiveFilters: function() {
		this.filtersView.renderActiveFilters()
	},

	//adapter method so that we don't break subclasses of this view when this logic was refactor into it's own view
	renderSecurityFilters: function() {
		this.filtersView.renderSecurityFilters()
		this.securityFilters = this.filtersView.securityFilters
	},

	renderSaveControls: function() {

		if (isSpectating()) {
			// No save controls, and no dirty form when working from a bookmark/briefing
			return
		}

		var saveMessageKey = this.isDatasetRoot() ?
			'datasets.new.unsaved' :
			'datasets.modified.unsaved'
		if (this.$('.save-controls').length) {
			this.$('.save-controls').remove()
		}
		this.$el.append(saveControls({ message: i18n.get(saveMessageKey) }))
		this.busyButton = new BusyButton({ el: this.$('.button-primary') })
		this.delegateEvents()

		// show or hide the save controls as appropriate
		this.dirty(_.isNil(this.request.dirty) ? false : this.request.dirty)

		// hide buttons we don't want
		//    move - never want this one.  use DND instead
		//    copy - not implemented yet.  eventually only for users with the admin datasets permission
		//    copy as template - never for datasets
		//    delete - never for the overview
		//    cancel - only for dataset views
		//    save as new (aka clone) - only for dataset views
		this.$('.move-copy-delete').addClass('is-not-displayed')
		this.$('.cancel, .save-as-new').toggleClass('is-not-displayed', this.isDatasetRoot())
		// Save and Save as New should always be enabled, because the whole
		// save controls will be hidden if they shouldn't be clickable
		this.$('.save, .save-as-new').removeClass('is-disabled')
		// always show the message
		this.$('.save-controls-message').removeClass('is-not-displayed')
	},

	secure: function() {
		if (!this.model.isModifyView()) {
			this.$('.save-controls').remove()
		}
	},

	togglePeriodDisplay: function() {
		let showPeriodDisplay = this.model.isSelectedCalendarFieldDefined()
		// see if any filters reference a relative period
		if (!showPeriodDisplay) {
			let allFilters = _.clone(this.filters || [])
			_.each(this.tables, table => {
				_.each(table.get('aggregations'), tableColumn => {
					if (tableColumn.dataSourceType === 'calculated') {
						_.each(tableColumn.aggregations, aggregation => {
							_.each(aggregation.filters, filter => {
								allFilters.push(filter)
							})
						})
					} else {
						_.each(tableColumn.filters, filter => {
							allFilters.push(filter)
						})
					}
				})
			})
			showPeriodDisplay = _.find(allFilters, filter => {
				if (!_.isNil(filter.periodDelta1) ||
					!_.isNil(filter.periodDelta2)) {
					return true
				}
			})
		}
		this.header.togglePeriodDisplay(showPeriodDisplay)
	},

	guard: function() {
		guard.guard(() => {
			return this.dirty() && this.model.isModifyView() &&
				// #35552 don't look at spectator b/c it's state is unreliable
				// when switching screens
				!_.isEmpty(this.$('.save-controls'))
		}, this.save.bind(this))
	},

	/**
	 * Hits the server for the results of a new dataset query, and renders the results
	 * @param data any additional data to be included with the request
	 */
	query: function(data) {
		// If we are adding a new filter, the other panels' content won't change,
		// so we don't need to show the loading dots for them
		var datasetData = data || {}
		if (!datasetData.newTable) {
			 this.loadingQueryResults()
		}
		var request = _.extend({
			id: this.model.id,
			selectedCalendarFieldId: this.model.get('selectedCalendarFieldId'),
			selectedCalendarVisibleLinkedFieldId: this.model.get('selectedCalendarVisibleLinkedFieldId'),
			calendarPeriodId: globals.periodId,
			filters: this.filters,
			records: this.records,
			tables: _.map(this.tables, table => table.toJSON()),
			showTables: this.showTables,
			total: this.total,
			maxRecords: _.result(this, 'maxRecords'),
			aggregationFieldId: this.getAggregationFieldId(),
			aggregationVisibleLinkedFieldId: this.getAggregationVisibleLinkedFieldId(),
			aggregationType: this.getAggregationType(),
			filterThroughLocalDataset: this.getFilterThroughLocalDataset(),
			// the server will only send the others when it actually makes sense
			others: true,
			// do NOT automatically mark the request dirty (#14039)
			dirty: this.request.dirty
		}, data)
		this.executeQuery(request).then(response => {
			this.response = response
			this.indexTrees()
			if (response.queryError) {
				this.handleQueryError(null, response.dataset)
			} else {
				// #35585 Update local filter state to get filter validity changes
				// from the server
				if (response.filters) {
					datasetRequests.save(_.extend(request, {
						filters: response.filters
					}))
					this._setFilters(response.filters)
				}
				this.renderQueryResults()
				this.showRecalculationBannerIfNeeded() // #55364
				this.filtersView.renderShowingXRecords(response)
			}
		}).catch(err => {
			if (err.statusText !== 'abort') { // #52465
				this.handleQueryError(err)
			}
		})

		// do NOT automatically mark the request dirty (#14039)
		datasetRequests.save(request)
		// #14152 make sure this.filtersByPermissionId is populated
		this._setFilters(this.filters)
		// Must be called after this.setFilters(), otherwise, the previous filters are applied
		this.renderActiveFilters()

		this.request = request

		if (debug) {
			console.log(JSON.stringify(request, null, '    '))
		}

		this.togglePeriodDisplay()
		this.removeBanner()
	},

	async handleQueryError(err, dataset = this.model) {
		let subsection

		// #49656
		// Use dynamic imports to avoid circular dependencies
		const DatasetsOverview = await import('scoreboard/datasets/overview/datasets-overview');
		const DatasetsRecords = await import('scoreboard/datasets/records/datasets-records')
		if (this instanceof DatasetsOverview.default) {
			subsection = 'overview'
		} else if (this instanceof DatasetsRecords.default) {
			subsection = 'records'
		}
		const notReadyView = new DatasetNotReady({
			model: wrapModel(dataset, Dataset),
			subsection,
			isQuickset: true
		}).on('ready', conductor.reload)
		await appDisplay.display(notReadyView)

		if (_.isNil(err)) return

		errorHandler(err.xhr)
	},

	removeBanner: function() {
		this.$('.banner').empty().addClass('is-not-displayed')
	},

	/**
	 * Allows a subclass to perform a more sophisticated request
	 * (e.g. datasets-records must use a streamer)
	 *
	 * @param {Object} request new request object
	 * @returns {Promise} resolves with the new response
	 */
	executeQuery(request) {
		const url = 'api/datasets/' + this.model.id + '/query'
		_.invoke(this.xhr, 'abort')
		this.xhr = $.post(url, JSON.stringify(request))
		return this.xhr
	},

	getFilterThroughLocalDataset: function() {
		return this.getFromRequestOrModel('filterThroughLocalDataset')
	},

	getAggregationFieldId: function() {
		return this.getFromRequestOrModel('aggregationFieldId')
	},

	getAggregationField() {
		let aggregationFieldId = this.getAggregationFieldId()
		return (aggregationFieldId && aggregationFieldId != TOTAL) ? this.model.combinedFieldsById[aggregationFieldId] : null
	},

	getAggregationVisibleLinkedFieldId: function() {
		if (_.isNil(this.request.aggregationFieldId)) {
			return this.model.get('aggregationVisibleLinkedFieldId')
		} else {
			return this.request.aggregationVisibleLinkedFieldId
		}
	},

	getFromRequestOrModel: function(field) {
		if (_.isNil(this.request[field])) {
			return this.model.get(field)
		} else {
			return this.request[field]
		}
	},

	getAggregationType: function() {
		if (this.getAggregationFieldId() == TOTAL ||
				_.isNil(this.getAggregationFieldId())) {
			return null
		}
		return this.request.aggregationType || this.model.get('aggregationType')
	},

	// gets or sets whether the current request is dirty
	dirty: function(dirty) {
		if (_.isNil(dirty)) {
			return this.request.dirty
		}

		this.request.dirty = dirty
		datasetRequests.save(this.request)
		var hideSaveControls = !dirty
		this.$('.save-controls').toggleClass('is-not-displayed', hideSaveControls)
	},

	saveAsNew: function() {
		const {rootId, organizationId} = this.model.attributes
		var relativeId = this.model.id

		// create a new view because we don't want a lot of fields that are in
		// the root dataset (e.g. status, primaryKeyFieldId)
		var props = _.pick(this.model.attributes, 'selectedCalendarFieldId',
			'administer', 'modifyViews', 'modifyRecords', 'modifyPermissions',
			'viewRecords', 'filterThroughLocalDataset',
			'selectedCalendarVisibleLinkedFieldId', 'rootDatasetId')
		var datasetView = new Dataset(_.extend({
			type: 'view',
			icon: 'dataset-view',
			filters: this.filters,
			tables: _.map(this.tables, table => table.toJSON()),
			aggregationFieldId: this.getAggregationFieldId(),
			aggregationVisibleLinkedFieldId: this.getAggregationVisibleLinkedFieldId(),
			aggregationType: this.getAggregationType(),
			rootId,
			organizationId
		}, props))
		// overwrite URL only when saving dataset views
		datasetView.url = 'api/datasets/' + rootId + '/view'

		// outside of datasets, we'll just use the default position determined by
		// the server
		if (conductor.section() === 'datasets') {
			// this breaks encapsulation, but IDK what else to do.  Realistically to
			// determine the position within the tree you have to have reference to
			// the underlying kalpa-tree.  I could try to factor the position code
			// out of the gardener, but I don't really see the point because then
			// we'd just have a dependency on the tree rather than the gardener.
			var gardener = appDisplay.navView().gardener
			// important: must make sure the type property is specified correctly,
			// or else the dataset gets added in the wrong place
			var position = gardener.getAddPosition(datasetView, relativeId)
			_.extend(datasetView.attributes, position)
		}

		var deferred = new $.Deferred()
		var labelForm = new LabelForm({
			model: datasetView,
			title: i18n.get('common.new2', 'datasets.view')
		})
		// after the submit is finished and we have a response from the server
		labelForm.on('done', function(model) {
			// at this point "model" is the newly saved view, and this.model is
			// whatever the state was before we saved (which may have been a
			// dataset or a view)
			this.recordOriginalState()
			// if we were on a dataset and then saved, clear out the request for
			// the dataset.  this matches what would have happened if we had
			// navigated from the dataset to the view.  the alternative is when
			// you revisit the dataset it says you haven't saved your changes, but
			// really you just did that!
			datasetRequests.remove(this.model.id)
			// important, or else revisiting dataset or view will have all the
			// changes in this new view rather than its original state
			this.request.id = model.id
			// #35728 set this view's tables property to what we received with the newly
			// saved dataset, since any HDao objects that are members of the dataset
			// (such as table.aggregations) will have been assigned IDs.
			this.initializeTables(model.get('tables'))
			// #53372 #53371 #51947 update the tables on the request to reflect
			// the current state, so we don't appear to lose any changes to
			// table settings when refreshing the page after saving as a new view
			// (since the request is saved to SessionStorage)
			this.request.tables = this.tables
			this.dirty(false)
			// this.model will be mutated to refer to the newly created dataset
			// view, so do a cloneDeep (#19360)
			this.model.datasetsById[this.model.id] = this.model.cloneDeep()
			// we're looking at the View now, not the dataset.  Keep the same
			// object so child objects are hooked into the correct model
			this.model.reset(_.extend(model.attributes, {
				primaryKeyFieldId: this.model.get('primaryKeyFieldId'),
				tracked: this.model.get('tracked'),
				fields: this.model.get('fields'),
				linkedDatasets: this.model.get('linkedDatasets'),
				visibleLinkedFields: this.model.get('visibleLinkedFields'),
				// #33230 be sure to keep this information around
				onlyUniquePaths: this.model.get('onlyUniquePaths')
			}))
			// #18888 be sure to remember the ID for the newly created view
			this.model.datasetsById[model.id] = this.model
			Backbone.trigger('add:domain-object', model, relativeId)
			conductor.navigate('datasets/' + model.id)
			// change the tabs so they point at the new ID
			_.each(this.$('.tab .sp-navigate'), function(el) {
				el = this.$(el)
				var href = el.attr('href')
				el.attr('href', conductor.changeIdUrl(href, model.id))
			}.bind(this))
			// now we're displaying a view instead of a dataset, so appropriately
			// update the save controls
			this.renderSaveControls()
			// #14313 the visibility of some controls may be different for dataset
			// views vs the root dataset overview
			this.header.secure()
			deferred.resolve()
		}.bind(this))
		// if coming from an unsaved changes prompt, get rid of that
		appDisplay.replaceDialog(labelForm)

		return deferred
	},

	save: function() {
		// on the datasets overview, the save button should behave like Save as New
		if (this.isDatasetRoot()) {
			return this.saveAsNew()
		}

		// logic below here for dataset views

		var deferred = new $.Deferred()
		_.invoke(this.busyButton, 'loading')
		// note: DatasetDeserializer requires type and rootId
		var savedAttributes = [ 'type', 'rootId', 'selectedCalendarFieldId',
			'selectedCalendarVisibleLinkedFieldId', 'rootDatasetId' ]
		var data = _.extend({
			filters: this.filters,
			tables: _.map(this.tables, table => table.toJSON()),
			// important to use these methods which look at the most recently
			// sent request for #14228
			aggregationType: this.getAggregationType(),
			aggregationFieldId: this.getAggregationFieldId(),
			aggregationVisibleLinkedFieldId: this.getAggregationVisibleLinkedFieldId(),
			ignorePermissions: true
		}, _.pick(this.model.attributes, savedAttributes))
		// we know exactly the information we want to PATCH.  Don't use
		// Backbone's version of PATCH because we don't want to compare
		// properties against the model (#14228)
		$.ajax({
			url: _.result(this.model, 'urlRoot') + '/' + this.model.id,
			method: 'patch',
			data: JSON.stringify(data),
			success: function(dataset) {
				this.recordOriginalState()
				this.model.set(dataset)
				// #53372 after saving, initialize the tables using the data
				// from the returned dataset so it is current
				this.initializeTables(_.get(dataset, 'tables', []))
				// #53372 #53371 #51947 update the tables on the request to reflect
				// the current state, so we don't appear to lose any changes to
				// table settings when refreshing the page after saving the view
				// (since the request is saved to SessionStorage)
				this.request.tables = this.tables
				Backbone.trigger('edit:domain-object', this.model, this.model.id)
				this.busyButton.done()
				this.busyButton.once('animation-complete', function() {
					this.dirty(false)
					this.trigger('done')
					// #14247 re-enabled the save button (it's hidden until a
					// change is actually made)
					this.busyButton.enable()
					deferred.resolve()
				}.bind(this))
			}.bind(this)
		})
		return deferred
	},

	cancel: function() {
		if (this.request.dirty) {
			datasetRequests.remove(this.model.id)
			// force a reload
			Backbone.history.loadUrl(Backbone.history.fragment)
		} else {
			this.dirty(false)

			this.request = _.cloneDeep(this.originalRequest)
			this._setFilters(_.cloneDeep(this.originalFilters))
			this.response = _.cloneDeep(this.originalResponse)
			this.tables = _.cloneDeep(this.originalTables)
			this.model.set('selectedCalendarFieldId', this.originalSelectedCalendarFieldId)

			// may need to show or hide the period selector
			this.header.render()
			this.renderQueryResults()
		}
	},

	//adapter method so that we don't break subclasses of this view when this logic was refactor into it's own view
	_setFilters: function(filters = []) {
		this.filters = filters
		this.filtersView.setFilters(filters)
	},

	/**
	 * To be overridden by sub-views.  Must return false if the view is not in
	 * a state that can be exported.
	 */
	isExportable: function() {
		return true
	},

	/**
	 * Show the banner at the top of the view with a given message.
	 * @param {String} message The banner message
	 */
	showBanner: function(message) {
		this.$('.banner').html(message).removeClass('is-not-displayed')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.header, this.busyButton, this.filtersView], 'remove')
		_.invokeMap(this.securityFilters || [], 'remove')
		guard.stopGuarding()
	},

	isDatasetRoot: function() {
		return this.model.get('type') === Dataset.DATASET
	}

})

export default DatasetsQueryView

DatasetsQueryView.__filename__ = 'datasets/datasets-query-view.js'
